import { createSlice } from '@reduxjs/toolkit';
import { themeGroupings } from '../constants/themeGroupings';
import { shiftTimeFrame } from './options.utils';

const lastFullYear = new Date().getFullYear() - 1;

const initTheme = themeGroupings[8];
// const initTheme = themeGroupings[1];
const initialState = {
  theme: initTheme.id,
  dataType: 'hazard',
  // dataType: 'climate',
  climateOption: 1001,
  // climateOption: 1012,
  climateRange: {
    min: 1981,
    max: lastFullYear,
    start: 1981,
    end: lastFullYear,
    minRange: 30,
  },
  hazardOption: 2016,
  // hazardOption: 2000,
  hazardMetric: 'count',
  hazardRange: {
    min: 1996,
    max: lastFullYear,
    start: 1996,
    end: lastFullYear,
    minRange: 5,
  },
  hurricaneRange: {
    min: 1842,
    max: lastFullYear,
    start: 1842,
    end: lastFullYear,
    minRange: 5,
  },
  lastFullYear,
  useAlternateData: false,
};

const optionsSlice = createSlice({
  name: 'options',
  initialState,
  reducers: {
    changeTheme(state, { payload: { id, dataType, attrId } }) {
      state.theme = id;
      state.dataType = dataType;
      state[`${state.useAlternateData || dataType}Option`] = attrId;
    },
    changeClimateOption(state, action) {
      state.climateOption = action.payload;
      state.dataType = 'climate';
    },
    changeHazardOption(state, action) {
      state.hazardOption = action.payload;
      state.dataType = 'hazard';
    },
    changeHazardMetric(state, action) {
      state.hazardMetric = action.payload;
    },
    changeDateRange(state, action) {
      state[`${state.useAlternateData || state.dataType}Range`] =
        shiftTimeFrame(
          ...action.payload,
          state[`${state.useAlternateData || state.dataType}Range`]
        );
    },
    changeUseAlternateData(state, action) {
      state.useAlternateData = action.payload;
    },
  },
});

export const {
  changeTheme,
  changeClimateOption,
  changeHazardOption,
  changeHazardMetric,
  changeDateRange,
  changeUseAlternateData,
} = optionsSlice.actions;
export default optionsSlice.reducer;
